var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationStatistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57143 8H4V28.4286C4 28.8453 4.16556 29.245 4.46026 29.5397C4.75496 29.8344 5.15466 30 5.57143 30H26V28.4286H5.57143V8Z",
    fill: "#176318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 14H20.4583V15.7143H23.3004L17.2917 22.22L13.8954 18.5343C13.8218 18.4539 13.7343 18.3902 13.6378 18.3467C13.5413 18.3031 13.4378 18.2807 13.3333 18.2807C13.2288 18.2807 13.1253 18.3031 13.0289 18.3467C12.9324 18.3902 12.8448 18.4539 12.7713 18.5343L7 24.7914L8.11625 26L13.3333 20.3514L16.7296 24.0371C16.8032 24.1175 16.8907 24.1812 16.9872 24.2248C17.0837 24.2683 17.1872 24.2907 17.2917 24.2907C17.3962 24.2907 17.4997 24.2683 17.5961 24.2248C17.6926 24.1812 17.7802 24.1175 17.8537 24.0371L24.4167 16.9229V20H26V14Z",
    fill: "#176318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1770_2461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationStatistic);
export default __webpack_public_path__ + "static/media/OperationStatistic.c04ea06dd64a67fe6c351eccfcc57295.svg";
export { ForwardRef as ReactComponent };